import DialogContentWrapper from "../../../../../../common/components/functional/dialogs/DialogContentWrapper";
import DialogComponent from "../../../../../../common/components/functional/dialogs/DialogComponent";
import { StripedTable } from "../../../../../../common/components/functional/stripedTable/StripedTable";
import { Box, Grid } from "@mui/material";
import TalentIntroductionsToCustomerTableRow from "./TalentIntroductionsToCustomerTableRow";
import { TalentIntroductionRow } from "../../../types";
import { StripedTableHeader } from "../../../../../../common/components/functional/stripedTable/types";
import { useState } from "react";
import { Nullable } from "../../../../../../common/types/nullable";
import TalentIntroductionsActionMenu from "../TalentIntroductionsActionMenu";
import OverlaySpinner from "../../../../../../common/components/functional/overlaySpinner/OverlaySpinner";
import { TablePaginationProps } from "../../../../../../common/components/functional/pagination/types";
import { useTranslation } from "react-i18next";

type Props = {
  open: boolean;
  toggleDialog: () => void;
  rows: TalentIntroductionRow[];
  selectActionForIntroduction?: (id: string, action: string) => void;
  isLoading: boolean;
  pagination: TablePaginationProps;
  withOrder?: boolean;
};

const TalentIntroductionsToCustomerDialog = ({
  open,
  toggleDialog,
  rows,
  selectActionForIntroduction,
  isLoading,
  pagination,
  withOrder,
}: Props) => {
  const [anchorEl, setAnchorEl] = useState<Nullable<HTMLElement>>(null);

  const { t } = useTranslation("talentProfile");

  const headers: StripedTableHeader[] = [
    { key: "date", label: t("common:date"), width: "5%" },
    { key: "customer", label: t("common:customer"), width: "42%" },
    { key: "workLocation", label: t("common:workLocation"), width: "23%" },
    { key: "workTitles", label: t("common:workTitles"), width: "15%" },
    {
      key: "status",
      label: t("invoices:status"),
      align: "right",
      width: "15%",
    },
    ...(selectActionForIntroduction ? [{ key: "action", label: "" }] : []),
  ];

  const handleCloseMenu = () => setAnchorEl(null);
  const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) =>
    setAnchorEl(event.currentTarget);

  const itemRows = rows.map((row, index) => (
    <TalentIntroductionsToCustomerTableRow
      key={`${row.bundleId ?? row.workLocationId}-${row.talentId}`}
      index={index}
      row={row}
      onClick={selectActionForIntroduction ? handleOpenMenu : undefined}
      withOrder={withOrder}
    />
  ));

  return (
    <DialogComponent
      open={open}
      onClose={toggleDialog}
      variant="form"
      autoWidth
    >
      <DialogContentWrapper
        title={t(
          withOrder
            ? "profileSummary.activeOrderIntroductions"
            : "profileSummary.introducedToCustomer",
        )}
        customCancelButtonLabel={t("common:close")}
        onCancel={toggleDialog}
        containerSx={{ width: "850px" }}
      >
        <Grid container item mt={1}>
          <Grid item xs={12}>
            <Box sx={{ maxHeight: "600px", overflowY: "auto" }}>
              <OverlaySpinner isLoading={isLoading} />
              <StripedTable
                disableRowClick
                columnHeaders={headers}
                itemRows={itemRows}
                headerSize="small"
                pagination={pagination}
              />
            </Box>
          </Grid>
        </Grid>
      </DialogContentWrapper>
      {selectActionForIntroduction && (
        <TalentIntroductionsActionMenu
          anchorEl={anchorEl}
          onClose={handleCloseMenu}
          selectActionForIntroduction={selectActionForIntroduction}
        />
      )}
    </DialogComponent>
  );
};

export default TalentIntroductionsToCustomerDialog;
